import { useSnackbar } from "notistack";
import { useMemo } from "react";

export interface IToastService {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

class ToastService implements IToastService {
  private enqueueSnackbar: (message: string, options?: any) => void;

  private static readonly OPTIONS_SUCCESS = {
    variant: "success",
    autoHideDuration: 3000,
  };
  private static readonly OPTIONS_ERROR = {
    variant: "error",
    autoHideDuration: 5000,
  };
  private static readonly OPTIONS_INFO = {
    variant: "info",
    autoHideDuration: 4000,
  };

  constructor(enqueueSnackbar: (message: string, options?: any) => void) {
    this.enqueueSnackbar = enqueueSnackbar;
  }

  success(message: string): void {
    this.enqueueSnackbar(message, ToastService.OPTIONS_SUCCESS);
  }

  error(message: string): void {
    this.enqueueSnackbar(message, ToastService.OPTIONS_ERROR);
  }

  info(message: string): void {
    this.enqueueSnackbar(message, ToastService.OPTIONS_INFO);
  }
}

export default function useToastService(): IToastService {
  const { enqueueSnackbar } = useSnackbar();
  return useMemo(() => new ToastService(enqueueSnackbar), [enqueueSnackbar]);
}
